<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="640px">
             <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <v-flex v-if="!Update_Details && !Delete_Details">Add Course Topic</v-flex>
                    <v-flex v-else-if="Update_Details">Update Course Topic</v-flex>
                    <v-flex v-else-if="Delete_Details">Delete Course Topic</v-flex>
                    <v-btn icon @click="CloseCourseModal"> 
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text v-if="!Update_Details && !Delete_Details">
                    <v-flex>
                        <v-select item-value='_id' item-text='name' return-object v-model="SelectedCourseDetail" :items="GetCourseDetailList" label="Select Course Title">
                            <template slot='selection' slot-scope='{ item }'>
                                {{ item.Course_Title }}
                            </template>
                            <template slot='item' slot-scope='{ item }'>
                                {{ item.Course_Title }}    
                            </template>
                        </v-select>
                    </v-flex>
                    <v-flex>
                        <v-text-field label="Section Title" v-model="Section_Title"></v-text-field>
                    </v-flex>
                    <v-flex>
                        <v-text-field label="Section Description" v-model="Section_Description"></v-text-field>
                    </v-flex>
                </v-card-text>
                <v-card-text v-else-if="Update_Details">
                    <v-flex>
                        <v-select @change='SectionSelected' item-value='_id' item-text='name' return-object v-model="SelectedSection" :items="Sections" label="Select Section">
                            <template slot='selection' slot-scope='{ item }'>
                                {{ item.Section_Title }}
                            </template>
                            <template slot='item' slot-scope='{ item }'>
                                {{ item.Section_Title }}    
                            </template>
                        </v-select>
                    </v-flex>
                    <v-flex>
                        <v-text-field v-model="Section_Title" label="Section Title"></v-text-field>
                    </v-flex>
                    <v-flex>
                        <v-text-field v-model="Section_Description" label="Section Description"></v-text-field>
                    </v-flex>
                </v-card-text>
                <v-card-text v-else-if="Delete_Details">
                    <v-flex>
                        <v-select @change='SectionSelected' item-value='_id' item-text='name' return-object v-model="SelectedSection" :items="Sections" label="Select Section">
                            <template slot='selection' slot-scope='{ item }'>
                                {{ item.Section_Title }}
                            </template>
                            <template slot='item' slot-scope='{ item }'>
                                {{ item.Section_Title }}    
                            </template>
                        </v-select>
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat v-if="!Update_Details && !Delete_Details" @click="AddCourseTopic">Add Topic</v-btn>
                    <v-btn color="primary" flat v-else-if="Update_Details" @click="UpdateCourse">Update Topic</v-btn>
                    <v-btn color="primary" flat v-else-if="Delete_Details" @click="DeleteCourseTopic">Delete Topic</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </section>
</template>
<script>
export default {
    props: ['dialog'],
    data(){
        return {

            Update_Details         : false,
            Delete_Details         : false,
            Section_Id             : "",
            Section_Title          : "",
            Section_Description    : "",
            SelectedCourseDetail   : {},
            Current_Course_Details : {},
            Sections               : [],
            SelectedSection        : {}
        }
    },
    computed:{  
        GetCourseDetailList(){

            return this.$store.getters.GetCourseDetailsList
        }
    },
    methods:{
        SectionSelected(){

            this.Section_Id          = this.SelectedSection['Section_Id']
            this.Section_Title       = this.SelectedSection["Section_Title"]
            this.Section_Description = this.SelectedSection["Section_Description"]
        },
        CloseCourseModal(){

            this.Section_Description   = ""
            this.Section_Title         = ""
            this.Section_Id            = ''
            this.SelectedCourseDetail  = {}
            this.Update_Details         = false
            this.Delete_Details         = false
            this.Current_Course_Details = {}
            this.Sections               = []
            this.SelectedSection        = {}
            this.$emit('close')
        },
        OpenUpdateTopic(item,type){
            
            type == "Update" ?   this.Update_Details = true : this.Delete_Details = true
            this.Sections = item['Course_Details']
            this.Current_Course_Details = item
        },
        DeleteCourseTopic(){

            let data = { "Course_Id": this.Current_Course_Details['_id'] ,"Section_Id": this.SelectedSection['Section_Id']}

            if(this.SelectedSection && this.SelectedSection['Section_Id']){

                this.$http.post(`${this.$store.getters.GetProductionUrl}/course/deletecoursetopic`,data)
                        .then(response =>{
                            
                            this.$store.commit('UpdateCourseDetails',response['data']['response'])
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Deleted Course Topic","Color":"green","Close": false });
                            this.CloseCourseModal()
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Deleting Course Topic","Color":"red","Close": false });
                        })
            }else{
                 this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Select Topic ","Color":"red","Close": false });
            }

        },
        AddCourseTopic(){

            let data = {}
            data["Course_Id"]     = this.SelectedCourseDetail["_id"]
            data["update"]        = {}
            data["update"]["Section_Title"]         = this.Section_Title
            data["update"]["Section_Description"]   = this.Section_Description

            if(this.Section_Title && this.Section_Description && Object.keys(this.SelectedCourseDetail).length > 0){
    
                this.$http.post(`${this.$store.getters.GetProductionUrl}/course/addcoursetopic`,data)
                            .then(response =>{
                                
                                this.$store.commit('UpdateCourseDetails',response['data']['response'])
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Added Course Topic","Color":"green","Close": false });
                                this.CloseCourseModal()
                            })
                            .catch(err =>{

                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Adding Course Topic","Color":"red","Close": false });
                            })

            }else{

                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Fill All The Details","Color":"red","Close": false });
            }
        },
        UpdateCourse(){

            let data = {}
            data["_id"] = this.Current_Course_Details['_id']
            data["Section_Id"] = this.Section_Id
            data["update"] = {}
            data["update"]["Section_Title"] = this.Section_Title
            data["update"]["Section_Description"] = this.Section_Description

            if(this.Current_Course_Details && this.Section_Id && this.Section_Title && this.Section_Description){
                
                this.$http.post(`${this.$store.getters.GetProductionUrl}/course/updatecoursetopic`,data)
                            .then(response =>{

                                this.$store.commit('UpdateCourseDetails',response['data']['response'])
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Updated Course","Color":"green","Close": false });
                                this.CloseCourseModal()
                            })
                            .catch(err =>{

                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Updating Course","Color":"red","Close": false });
                            })
            }else{

                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Update Course","Color":"red","Close": false });
            }
        },
    }
}
</script>
<style scoped>

</style>
